import React, { useContext, useEffect, useState } from 'react'
import { useQuery, useMutation } from '@apollo/client'
import {
  CREATE_INTERNAL_NOTE_REQUEST,
  GET_INTERNAL_NOTES_REQUEST,
} from '../../../graphql/Catalog/InternalNotes/internalNotes'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import { AuthContext } from '../../../Auth/AuthContext'
import pdfIcon from '../../../Assets/icons/pdf.svg'
import { useRef } from 'react'
import moment from 'moment'
import { useLoading } from '../../../LoadingOverlay/LoadingOverlayContext'
import GlobeIcon from '../../../Assets/icons/Icon awesome-globe-africa.svg'
import IncognitoIcon from '../../../Assets/icons/incognito.svg'

const InternalNotesRequest = ({
  category_note,
  request_id,
  jurisdiction_id,
  flagSwitchInternalMode = true,
}) => {
  const { user } = useContext(AuthContext)
  const { showLoading, hideLoading } = useLoading()

  //--------- Hooks to save data ------------
  const [values, setValues] = useState({
    text: '',
    document: '',
    internal: false,
  })
  const [messages, setMessages] = useState(null)
  const [previewFile, setPreviewFile] = useState(null)
  const [loadingUpload, setLoadingUpload] = useState(false)
  const { text, document } = values
  const refResetDocument = useRef()
  const boxScroll = useRef()

  //---------- Queries and Mutations ---------
  const [createNote] = useMutation(CREATE_INTERNAL_NOTE_REQUEST, {
    refetchQueries: [
      {
        query: GET_INTERNAL_NOTES_REQUEST,
        variables: {
          category_notes: [category_note, 'status'],
          requestId: request_id,
        },
        fetchPolicy: 'no-cache',
      },
    ],
  })
  const { data, loading, error, refetch } = useQuery(
    GET_INTERNAL_NOTES_REQUEST,
    {
      variables: {
        category_notes: [category_note, 'status'],
        requestId: request_id,
      },
      fetchPolicy: 'no-cache',
    }
  )

  //---------- UseEffects ----------
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      //PINTAR DATOS EN INTERNAL
      let list = []
      let internal = false
      data.getInternalNotesRequest.map((item) => {
        // if (
        //   (item.internal && user?.jurisdiction_id !== jurisdiction_id) ||
        //   !item.internal
        // )
        //   if (item?.category_note != 'status') internal = item?.internal

        list.push({
          user: item?.user?.name ? item.user.name : '',
          text: item?.text ? item.text : '',
          file: item?.fileInternal?.url ? item.fileInternal.url : '',
          type: item?.type ? item.type : '',
          date: item?.createdAt
            ? moment(item.createdAt).format('DD/MM/YY hh:mm a')
            : '',
          internal: item?.internal ? item.internal : false,
          category_note: item?.category_note,
        })
        return true
      })
      if (list.length > 0)
        setValues({
          ...values,
          internal,
        })

      setMessages(list)
    }
  }, [data, loading, error])

  const handleChange = ({ target }) => {
    setValues({
      ...values,
      [target.name]: target.value,
    })
  }

  const sendInternalNotes = async () => {
    //Validate inputs data
    if (!text && !document)
      return toastSweetAlert({
        mode: 'error',
        message: 'Debe escribir o subir un documento',
      })

    setLoadingUpload(true)
    showLoading()

    let type = null

    if (document) {
      type = document.type.split('/')
      if (
        type[1] !== 'pdf' &&
        type[0] !== 'image' &&
        type[1] !== 'jpg' &&
        type[1] !== 'png' &&
        type[1] !== 'jpeg'
      ) {
        setLoadingUpload(false)
        hideLoading()

        return toastSweetAlert({
          mode: 'error',
          message: 'Archivo incompatible',
        })
      }
      if (document.size > 5242880) {
        setLoadingUpload(false)
        hideLoading()
        return toastSweetAlert({
          mode: 'error',
          message: 'Archivo es demasiado pesado',
        })
      }
    }
    //Insert data
    try {
      await createNote({
        variables: {
          input: {
            user_id: user.idUser,
            category_note: category_note,
            request_id: request_id,
            text: text === '' ? null : text,
            file: document === '' ? null : document,
            type: document ? type[1] : null,
            internal: values.internal,
          },
        },
      })
      //If the Insert was a successfull
      setValues({
        text: '',
        document: '',
        internal: values.internal,
      })
      await refetch()
      setLoadingUpload(false)
      hideLoading()
      refResetDocument.current.value = ''
      return
    } catch (e) {
      setLoadingUpload(false)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const handleSetUpload = (e) => {
    setValues({ ...values, document: e.target.files[0] })
    putPreview(e)
  }

  const putPreview = (e) => {
    var fileToLoad = e.target.files[0]
    var fileReader = new FileReader()
    var base64File
    fileReader.onload = function (event) {
      base64File = event.target.result
      setPreviewFile(base64File)
    }

    fileReader.readAsDataURL(fileToLoad)
  }

  /* set Scroll to bottom position */
  useEffect(() => {
    if (boxScroll) {
      const element = boxScroll.current
      element.scrollTop = element.scrollHeight

      setTimeout(() => {
        const divs = element.getElementsByTagName('div')
        const lastDiv = divs[divs.length - 1]
        lastDiv.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, 400)
    }
  }, [boxScroll, data, loading, error])

  const handleDeleteDoc = () => {
    return (
      setValues(...values, { text: '', document: '' }),
      setPreviewFile(null),
      (refResetDocument.current.value = '')
    )
    // document.getElementById('internalNotesDocument').value = ''
    // document.getElementById('').value = ''
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      window.document.getElementById('uploadMessage').click()
    }
  }

  return (
    <div className="row internal-notes">
      <div className="col-12">
        <div className="card">
          <div className="card-header py-1">
            <h3 className="card-title pl-3 mt-0">Notas internas</h3>
          </div>
          <div
            className={`card-body internalNotes-body ${
              loadingUpload ? 'processing-file' : ''
            }`}
          >
            {/* Show history */}
            <div ref={boxScroll} className="boxHistory">
              {messages?.length > 0 ? (
                <div className="body">
                  {messages.map((item, index) => (
                    <React.Fragment key={index}>
                      {(item.category_note === 'status' ||
                        (item.category_note === 'request' &&
                          !values.internal) ||
                        (item.category_note === 'request' &&
                          values.internal &&
                          item.internal)) && (
                        <div
                          className={`${
                            item?.category_note === 'status' && 'status-box'
                          } ${item?.internal && 'internal-box'} msg ${
                            item?.user_id === user.idUser &&
                            item?.category_note !== 'status' &&
                            'my-msg'
                          }`}
                        >
                          <div className="mt-4 msg-header">
                            {item?.category_note !== 'status' && (
                              <span className="title-details">
                                {item.user}{' '}
                                {item?.charge && `(${item?.charge})`}
                                &nbsp;&nbsp;
                              </span>
                            )}
                            {item.text === '' && item.file && (
                              <>
                                <i className="fas fa-file"></i>
                                {item?.internal ? (
                                  <i className="fas fa-lock ml-1"></i>
                                ) : (
                                  <i className="fas fa-globe ml-1"></i>
                                )}
                              </>
                            )}
                            {item.text && item?.category_note !== 'status' && (
                              <>
                                {item?.internal ? (
                                  <img src={IncognitoIcon} alt="incognito" />
                                ) : (
                                  <img src={GlobeIcon} alt="globe" />
                                )}
                              </>
                            )}

                            {item?.category_note === 'status' && (
                              <div className={`${'status-date'}`}>
                                {item.date}
                              </div>
                            )}
                          </div>

                          <div
                            className={`${
                              item?.category_note !== 'status' && 'msg-content'
                            }`}
                          >
                            {item.text && (
                              <span
                                className={`${
                                  item?.category_note === 'status'
                                    ? 'content-details-status'
                                    : 'content-details'
                                }`}
                              >
                                {item?.category_note === 'status' ? (
                                  <>El estado cambio a {item.text}</>
                                ) : (
                                  item.text
                                )}
                              </span>
                            )}
                            {/* {item.text && item?.category_note === 'status' && (
                              <div className="progress-bar-status-box">
                                <ProgressBarStatusReport
                                  statusReport={item?.status}
                                />
                              </div>
                            )} */}
                            {item?.category_note === 'status' ? (
                              <>
                                <span className="status-details">
                                  {item.status_id}
                                </span>
                              </>
                            ) : (
                              <>
                                <br />
                                {item.type && item.type === 'image' && (
                                  <a
                                    href={item.file}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Ver imágen completa"
                                  >
                                    <img
                                      className="img-internal-notes hover-overlay"
                                      src={item.file}
                                      alt="Internal Notes images"
                                    />
                                  </a>
                                )}
                                {item.type && item.type === 'pdf' && (
                                  <div className="files">
                                    <a
                                      className="documentLink"
                                      href={item.file}
                                      target="_blank"
                                      rel="noreferrer"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title="Descargar documento"
                                    >
                                      Documento PDF &nbsp;
                                      <i className="fas fa-file"></i>
                                    </a>
                                  </div>
                                )}
                              </>
                            )}
                          </div>

                          {item?.category_note !== 'status' && (
                            <div className="date mr-2">{item.date}</div>
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              ) : (
                <div>
                  <div className="text-center">
                    <label>Sin historial</label>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="card-footer">
            {/* Inputs */}
            <div className="boxInput">
              <label htmlFor="internalNotesDocument" id="labelDocument">
                <i class="fas fa-plus" />
              </label>
              <input
                type="text"
                placeholder="Escribe un mensaje"
                id="internalNotesText"
                name="text"
                value={values.text}
                onChange={handleChange}
                autoComplete="off"
                onKeyDown={onKeyDown}
              />
              <input
                type="file"
                id="internalNotesDocument"
                name="document"
                onChange={(e) => handleSetUpload(e)}
                ref={refResetDocument}
                accept=".jpg, .jpeg, .png, .pdf"
              />
              <button
                id="uploadMessage"
                onClick={sendInternalNotes}
                disabled={loadingUpload}
              >
                <i className="fas fa-paper-plane"></i>
              </button>
            </div>
            {values.document && (
              <div className="preview-docs">
                {/* <span
                  style={{
                    cursor: 'pointer',
                  }}
                  className="icon-delete-document"
                  onClick={handleDeleteDoc}
                >
                  <i class="fas fa-trash"></i>
                </span> */}
                {values.document.type.includes('image') ? (
                  <img
                    src={previewFile}
                    style={{ width: '50px' }}
                    alt="previewUploadImg"
                  />
                ) : (
                  <img
                    src={pdfIcon}
                    style={{ width: '50px' }}
                    alt="previewUploadDoc"
                  />
                )}
                <label>{values.document.name}</label>
              </div>
            )}
            {/* {flagSwitchInternalMode && (
              <div className="global-switch">
                <label className="label-description">Modo Interno</label>
                <label class="switch">
                  <input
                    checked={values?.internal}
                    type="checkbox"
                    onChange={(e) =>
                      setValues({ ...values, internal: e.target.checked })
                    }
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  )
}
export default InternalNotesRequest
